import { get, chain } from "lodash"
import { createSelector } from "reselect"
import { getIsSuperuser } from "modules/account-root/selectors"
import { getRoute, getPath } from "selectors/urls"
import { computeDatasetPermissionsTabs } from "helpers/permissions/tabs"

function isDirectToken(entitlement) {
  return get(entitlement, "direct") && get(entitlement, "token")
}

export const getDatasetTokens = (state) => chain(state)
  .get("global.data.datasetEntitlements.data")
  .filter(isDirectToken)
  .map("token")
  .value()

export const getTokens = (_, props) => get(props, "tokens.tokens")

export const getTabs = createSelector(
  [getRoute, getPath, getIsSuperuser],
  computeDatasetPermissionsTabs,
)
